import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ItemBase from './ItemBase';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledList = /*#__PURE__*/styled.ol.withConfig({
  displayName: "OrderedListBase__StyledList",
  componentId: "components-web__sc-4m9lgj-0"
})({
  display: 'flex',
  flexDirection: 'column',
  listStylePosition: 'inside',
  margin: 0,
  padding: 0
});

/**
 * Semantic ordered list.
 */
const OrderedListBase = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    start = 1,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(StyledList, {
    ...rest,
    ref: ref,
    start: start,
    children: children
  });
});
OrderedListBase.displayName = 'OrderedList';
OrderedListBase.propTypes = {
  /**
   * A list of ordered items wrapped in `OrderedListBase.Item`.
   */
  children: PropTypes.node.isRequired,
  /**
   * The position to start the list with.
   */
  start: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
OrderedListBase.Item = ItemBase;
export default OrderedListBase;